export default __webpack_public_path__ + "static/media/tab_filter.d5aa0014.svg";